<template>
  <div class="container-roles full-height">
    <q-card class="my-card full-height">
      <q-card-section>
        <div class="row">
          <div class="col-12">
            <q-table
              title="Roles de la aplicación"
              data-cy="list-roles"
              row-key="id"
              flat
              :pagination.sync="pagination"
              :columns="columns"
              :data="arrayRoles"
              :loading="isLoadingData"
            >
              <template v-slot:top-right>
                <div>
                  <q-btn
                    data-cy="new-rol"
                    color="primary"
                    label="CREAR ROL"
                    icon="settings"
                    @click="triggerNew()"
                  />
                </div>
              </template>
              <template v-slot:body="props">
                <q-tr :props="props" style="cursor: pointer">
                  <q-td
                    key="name"
                    :props="props"
                    data-cy="app-rol"
                  >
                    {{ props.row.name }}
                    <q-popup-edit
                      v-if="!props.row.default"
                      v-model="props.row.name"
                      @save="(v) => editRole(props.row.id, v)"
                      auto-save
                    >
                      <q-input
                        v-model="props.row.name"
                        dense
                        autofocus
                        counter
                        data-cy="editrol_name"
                      />
                    </q-popup-edit>
                  </q-td>
                  <q-td key="eliminar" :props="props">
                    <q-icon
                      name="o_delete"
                      style="color: #002f6c; font-size: 24px"
                      @click="triggerDelete(props.row)"
                      :disabled="props.row.default"
                      data-cy="delete-rol"
                    />
                  </q-td>
                </q-tr>
              </template>
            </q-table>
          </div>
        </div>
      </q-card-section>
    </q-card>
    <DialogCreate
      v-model="showDialogCreate"
      title="Crear un nuevo Rol"
      dataCy="create-rol"
      @save="newRole()"
      :isLoading="isLoading"
    >
      <template slot="body">
        <div class="input-row">
          <q-input
            v-model="name"
            :error="v$.name.$error"
            outlined
            debounce="1000"
            label="*Nombre rol"
            class="col-12"
            data-cy="newrol_name"
          >
            <template v-slot:error>Dato obligatorio.</template>
          </q-input>
        </div>
      </template>
    </DialogCreate>
    <DialogDelete
      v-if="roleSelected"
      v-model="showDialogDelete"
      :showIcon="true"
      :txtContainer="`¿Está seguro de eliminar el rol ${roleSelected.name}?`"
      @save="removeRole()"
      :isLoading="isLoading"
      dataCy="confirm-delete-rol"
    />
  </div>
</template>

<script>
import { QTable, QTr, QTd, QPopupEdit } from 'quasar';
import Loading from '@/components/shared/mixins/Loading.js';
import Message from '@/components/shared/mixins/Message.js';
import DialogDelete from '@/shared/dialogs/delete/DialogDelete.vue';
import DialogCreate from '@/shared/dialogs/create/DialogCreate.vue';
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';

export default {
  setup: () => ({ v$: useVuelidate() }),
  components: {
    QTable,
    QTd,
    QTr,
    QPopupEdit,
    DialogDelete,
    DialogCreate
  },
  props: {
    idApp: {
      required: true
    }
  },
  mixins: [Loading, Message],
  validations: {
    name: { required }
  },
  data: function () {
    return {
      name: null,
      arrayRoles: [],
      pagination: {
        sortBy: 'name',
        descending: false,
        rowsPerPage: 20
      },
      columns: [
        {
          name: 'name',
          label: 'Rol',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'eliminar',
          label: 'Acciones',
          align: 'center',
          field: 'enabled',
          sortable: false
        }
      ],
      showDialogDelete: false,
      showDialogCreate: false,
      roleSelected: null,
      isLoading: false,
      isLoadingData: false
    };
  },
  mounted () {
    this.roleSelected = null;
  },
  methods: {
    async _getRolApp () {
      this.showLoading();
      this.isLoadingData = true;
      let request = {
        controller: `/Rol/${this.idApp}`
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then((response) => {
          this.arrayRoles = response.data;
          this.hideLoading();
        })
        .catch((err) => {
          this.showError(err.message);
          this.hideLoading();
        });

      this.isLoadingData = false;
    },
    async editRole (id, v) {
      // Comprobar que tenga datos y el id sea valido.
      this.isLoadingData = true;
      this.showLoading();

      let dataArray = {
        id: id,
        name: v
      };

      let request = {
        controller: `/Rol/${this.idApp}`,
        filter: {},
        body: dataArray
      };

      await this.$store
        .dispatch('PF/putSuit', request)
        .then((response) => {
          this.hideLoading();
          this._getRolApp();

          // Emitir evento de actualización de Roles
          this.$eventHub.$emit('ACTUALIZAR_LISTA_ROLES');
          this.$eventHub.$emit('refreshlistUsers');
        })
        .catch((err) => {
          this.showError(err.message);
          this.hideLoading();
        });

      this.isLoadingData = false;
    },
    triggerNew () {
      this.showDialogCreate = true;
    },
    async newRole () {
      this.v$.$touch();
      if (this.v$.$error) return;

      this.isLoading = true;
      this.showLoading();

      let dataArray = {
        name: this.name
      };

      let request = {
        controller: `/Rol/${this.idApp}`,
        filter: {},
        body: dataArray
      };

      await this.$store
        .dispatch('PF/postSuit', request)
        .then((response) => {
          this.hideLoading();
          this.showMessage(`Rol ${this.name} creado correctamente.`);
          this.showDialogCreate = false;
          this._getRolApp();

          // Empty Create Dialog Form and reset
          this.name = null;
          this.v$.$reset();

          // Emitir evento de actualización de Roles
          this.$eventHub.$emit('ACTUALIZAR_LISTA_ROLES');
          this.$eventHub.$emit('refreshlistUsers');
        })
        .catch((err) => {
          this.showError(err.message);
          this.hideLoading();
        });

      this.isLoading = false;
    },
    triggerDelete (row) {
      if (row.default) return;
      this.roleSelected = row;
      this.showDialogDelete = true;
    },
    async removeRole () {
      this.isLoading = true;
      this.showLoading();

      let request = {
        controller: `/Rol/${this.idApp}/${this.roleSelected.name}`,
        filter: {}
      };

      await this.$store
        .dispatch('PF/deleteSuit', request)
        .then((response) => {
          this.hideLoading();
          this.showMessage(`Rol ${this.roleSelected.name} eliminado correctamente.`);
          this.showDialogDelete = false;
          this._getRolApp();
          this.$eventHub.$emit('refreshlistUsers');
        })
        .catch((e) => {
          this.showError(e.message);
          this.hideLoading();
        });

      this.isLoading = false;
    }
  },
  watch: {
    idApp: {
      handler: function (val) {
        if (val) this._getRolApp();
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container-roles {
  .input-row {
    padding: 16px 0px;
  }
}
</style>
